import useAxios from '@/hooks/useAxios'
import axios from 'axios'

const { get, post } = useAxios()

export const getAgent = () => get('/common/get_agent_config')

export const searchPlace = (value: string) =>
  axios.get(
    `https://app.addresser.com.au/autocomplete_demo?search_input=${value}&pdt=0&gnaf=0&limit=10&states=ACT,NSW,NT,QLD,SA,TAS,VIC,WA`
  )
